import { action } from "typesafe-actions";

import { message } from "antd";

import {
  DateRangePayload,
  GatePayload,
  MarkerPayload,
  OrderingPayload,
  PaginatedResponse,
  PaginationPayload,
  ReportPayload,
} from "../common_types";
import { CurrencyPayload } from "../currencies/types";
import { MarketPayload } from "../markets/types";

import { ClickItem, ClicksActionTypes } from "./types";

export const tableFetchRequest = (
  payload: DateRangePayload & PaginationPayload & MarketPayload & CurrencyPayload & OrderingPayload & GatePayload
) => action(ClicksActionTypes.TABLE_FETCH_REQUEST, payload);

export const tableFetchSuccess = (payload: PaginatedResponse<ClickItem>) =>
  action(ClicksActionTypes.TABLE_FETCH_SUCCESS, payload);

export const tableFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ClicksActionTypes.TABLE_FETCH_ERROR);
};

export const retrieveFetchRequest = (payload: MarkerPayload & GatePayload & CurrencyPayload) =>
  action(ClicksActionTypes.RETRIEVE_FETCH_REQUEST, payload);

export const retrieveFetchSuccess = (payload: ClickItem) => action(ClicksActionTypes.RETRIEVE_FETCH_SUCCESS, payload);

export const retrieveFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ClicksActionTypes.RETRIEVE_FETCH_ERROR);
};

export const reportGeneratorTaskCreateRequest = (
  payload: ReportPayload & DateRangePayload & MarketPayload & CurrencyPayload & OrderingPayload & GatePayload
) => action(ClicksActionTypes.GENERATE_REPORT_REQUEST, payload);
